module.exports = __webpack_public_path__ + "static/img/flower.8375026.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/flower.png
// module id = hEOr
// module chunks = 0